/**
 * Skeleton row used while documents are loading. Matches the height/rhythm of
 * a real row so the layout doesn't jump when data arrives.
 */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function DocumentRowSkeleton() {
    return /*#__PURE__*/ _jsxs("li", {
        className: "flex items-center gap-3 px-4 py-3 animate-pulse",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "w-5 h-5 rounded bg-muted"
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex-1 min-w-0 space-y-2",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "h-3 w-2/5 bg-muted rounded"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "h-2 w-1/3 bg-muted/70 rounded"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "w-8 h-8 rounded bg-muted/60"
            })
        ]
    });
}
/**
 * Grid skeleton for folder tiles. Renders four placeholders.
 */ export function FolderGridSkeleton() {
    return /*#__PURE__*/ _jsx("ul", {
        className: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2",
        children: [
            0,
            1,
            2,
            3
        ].map((i)=>/*#__PURE__*/ _jsxs("li", {
                className: "rounded-md border px-3 py-2 flex items-center gap-2 animate-pulse",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "w-5 h-5 rounded bg-muted"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "h-3 w-2/3 bg-muted rounded"
                    })
                ]
            }, i))
    });
}
